/* Bounded, in-memory collection history. Nothing persists between visits. */
(() => {
  const entries = new Map();
  let displayed = location.pathname + location.search;
  const key = url => { const u = new URL(url, location.origin); return u.pathname + u.search; };
  function capture() {
    const grid = document.querySelector('.js-products-grid');
    const button = document.querySelector('.js-load-more');
    if (!grid || !button || grid.getAttribute('aria-busy') === 'true') return;
    const entry = { html:grid.innerHTML, count:document.querySelector('#products-count')?.value, button:{...button.dataset}, highest:document.querySelector('#highest-price')?.textContent, y:scrollY, time:Date.now() };
    if (entry.html.length > 1500000) return;
    entries.delete(displayed); entries.set(displayed,entry);
    while (entries.size > 5) entries.delete(entries.keys().next().value);
  }
  function read(url) {
    const entry=entries.get(key(url));
    return entry && Date.now()-entry.time < 600000 ? entry : null;
  }
  let countryReturn = '';
  function syncCountryReturn() {
    const current = location.pathname + location.search + location.hash;
    if (countryReturn === current) return;
    countryReturn = current;
    const fields = [...document.querySelectorAll('form[action$="/localization"] input[name="return_to"]')];
    const welcome = document.getElementById('dac-country-welcome-template');
    if (welcome) fields.push(...welcome.content.querySelectorAll('input[name="return_to"]'));
    fields.forEach(input => { input.value = current; });
  }
  function commit() { displayed=key(location.href); syncCountryReturn(); capture(); }
  let frame=0;
  addEventListener('scroll',()=>{
    if (frame) return;
    frame=requestAnimationFrame(()=>{frame=0;const entry=entries.get(displayed);if(entry)entry.y=scrollY;});
  },{passive:true});
  document.addEventListener('dac:products-grid-updated',commit);
  document.addEventListener('dac:plp-filter-applied',commit);
  document.addEventListener('DOMContentLoaded',()=>{syncCountryReturn();capture();});
  // Store geometry only, so an uncached Back can reserve loaded rows without
  // generating hundreds of skeleton cards or persisting product HTML.
  const storageKey='dac.collection.return';
  let saved, restoring=false, departure, departed=false;
  try { saved=JSON.parse(sessionStorage.getItem(storageKey)||'null'); } catch {}
  const backward=performance.getEntriesByType?.('navigation')?.[0]?.type==='back_forward';
  const grid=document.querySelector('.js-products-grid');
  const notice=document.createElement('div');notice.className='dac-restore-notice';notice.setAttribute('role','status');notice.textContent="Gendanner din placering…";
  if(backward && saved?.url===location.href && saved.width===innerWidth && Date.now()-saved.time<1800000 && grid) {
    restoring=true;
    if(Number(new URLSearchParams(location.search).get('page'))>1) {
      grid.style.minHeight=saved.height+'px';grid.style.alignContent='start';grid.style.visibility='hidden';
      document.body.append(notice);
    }
    requestAnimationFrame(()=>{if(!departed)scrollTo({top:saved.y,behavior:'instant'});});
  }
  function finishRestore() {
    if(!restoring)return;
    restoring=false;grid.style.minHeight='';
    requestAnimationFrame(()=>{if(!departed)scrollTo({top:saved.y,behavior:'instant'});grid.style.visibility='';notice.remove();});
    try { sessionStorage.removeItem(storageKey); } catch {}
  }
  document.addEventListener('dac:products-grid-updated',finishRestore);
  document.addEventListener('dac:restore-failed',()=>{restoring=false;if(grid){grid.style.minHeight='';grid.style.visibility='';}notice.remove();});
  document.addEventListener('dac:filter-state-changed',()=>{restoring=false;if(grid){grid.style.minHeight='';grid.style.visibility='';}notice.remove();});
  addEventListener('pageshow',event=>{
    if(event.persisted) {
      const position=departure;
      if(grid && position?.url===location.href && Number.isFinite(position.y) && position.y>0 && scrollY===0 &&
        position.width===innerWidth && position.scale===1 && (window.visualViewport?.scale??1)===1 &&
        document.documentElement.scrollHeight-innerHeight>=position.y) {
        scrollTo({top:position.y,behavior:'instant'});
      }
      return;
    }
    if(Number(new URLSearchParams(location.search).get('page')||1)===1)finishRestore();
  },{capture:true});
  addEventListener('pagehide',()=>{
    departed=true;
    capture();
    if(!grid)return;
    departure={url:location.href,y:scrollY,width:innerWidth,scale:window.visualViewport?.scale??1};
    try { sessionStorage.setItem(storageKey,JSON.stringify({url:location.href,y:scrollY,width:innerWidth,height:grid.getBoundingClientRect().height,time:Date.now()})); } catch {}
  });

  // Align collection FAQs with the description column and follow collection layout changes.
  function dacAlignCollectionFaqs() {
    const description = document.querySelector('.collection-description');
    const groups = Array.from(document.querySelectorAll('.template-collection [data-faq-group]'));
    groups.forEach(group => {
      group.style.removeProperty('transform');
      group.style.removeProperty('width');
    });
    if (!description || groups.length === 0) return;
    const descriptionRect = description.getBoundingClientRect();
    groups.forEach(group => {
      group.style.width = descriptionRect.width + 'px';
      const offset = descriptionRect.left - group.getBoundingClientRect().left;
      group.style.transform = offset ? 'translateX(' + offset + 'px)' : '';
    });
  }
  function dacInitializeCollectionFaqAlignment() {
    if (!document.querySelector('.template-collection [data-faq-group]')) return;
    dacAlignCollectionFaqs();
    window.addEventListener('resize', dacAlignCollectionFaqs, { passive: true });
    const description = document.querySelector('.collection-description');
    if (description && window.ResizeObserver) new ResizeObserver(dacAlignCollectionFaqs).observe(description);
    const layout = document.querySelector('.dac-collection');
    if (layout && window.MutationObserver) {
      new MutationObserver(dacAlignCollectionFaqs).observe(layout, { attributes: true, attributeFilter: ['data-desktop-filters'] });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dacInitializeCollectionFaqAlignment, { once: true });
  } else {
    dacInitializeCollectionFaqAlignment();
  }

  window.dacCollectionHistory={capture,read,commit};
})();
